import React from "react";
import LegalPageLayout from "./LegalPageLayout";

// ✅ Import All Legal Pages
import TermsOfUse from "./TermsOfUse";
import TermsAndConditions from "./TermsAndConditions";
import PrivacyPolicy from "./PrivacyPolicy";
import RefundPolicy from "./RefundPolicy";
import Disclaimer from "./Disclaimer";
import CookiePolicy from "./CookiePolicy";
import CodeOfConduct from "./CodeOfConduct";
import AdvisorConduct from "./AdvisorConduct";
import TrademarkNotice from "./TrademarkNotice";
import KYCPolicy from "./KYCPolicy";
import KYCAMLPolicy from "./KYCAMLPolicy";
import GDPRCompliance from "./GDPRCompliance";
import GlobalCompliancePolicy from "./GlobalCompliancePolicy";
import RiskDisclaimer from "./RiskDisclaimer";
import TrustSafetyPolicy from "./TrustSafetyPolicy";
import PlatformIntegrityPolicy from "./PlatformIntegrityPolicy";
import ServiceProviderAgreement from "./ServiceProviderAgreement";
import TaxDeclarationPolicy from "./TaxDeclarationPolicy";
import TerminationPolicy from "./TerminationPolicy";
import ThirdPartyDataProcessors from "./ThirdPartyDataProcessors";
import SponsoredContentPolicy from "./SponsoredContentPolicy";
import ContentUsagePolicy from "./ContentUsagePolicy";
import CommunityGuidelines from "./CommunityGuidelines";
import CommissionRevenuePolicy from "./CommissionRevenuePolicy";
import AffiliateMarketingPolicy from "./AffiliateMarketingPolicy";
import PayoutPolicy from "./PayoutPolicy";
import JurisdictionAgePolicy from "./JurisdictionAgePolicy";
import DMCAPolicy from "./DMCAPolicy";
import GlobalDisputeResolutionPolicy from "./GlobalDisputeResolutionPolicy";
import IntellectualPropertyRights from "./IntellectualPropertyRights";
import InstructorCertificationPolicy from "./InstructorCertificationPolicy";
import UserGeneratedContentPolicy from "./UserGeneratedContentPolicy";
import Verification from "./Verification";
import LegalIndex from "./LegalIndex";

const legalRoutes = [
  // Terms Group
  { path: "/legal", element: <LegalIndex /> },
  {
    path: "/legal/terms-of-use",
    element: (
      <LegalPageLayout>
        <TermsOfUse />
      </LegalPageLayout>
    ),
  },
  {
    path: "/legal/terms-and-conditions",
    element: (
      <LegalPageLayout>
        <TermsAndConditions />
      </LegalPageLayout>
    ),
  },

  // Privacy Group
  {
    path: "/legal/privacy-policy",
    element: (
      <LegalPageLayout>
        <PrivacyPolicy />
      </LegalPageLayout>
    ),
  },
  {
    path: "/legal/refund-policy",
    element: (
      <LegalPageLayout>
        <RefundPolicy />
      </LegalPageLayout>
    ),
  },
  {
    path: "/legal/disclaimer",
    element: (
      <LegalPageLayout>
        <Disclaimer />
      </LegalPageLayout>
    ),
  },
  {
    path: "/legal/cookie-policy",
    element: (
      <LegalPageLayout>
        <CookiePolicy />
      </LegalPageLayout>
    ),
  },

  // KYC/AML/Data Protection
  {
    path: "/legal/kyc-policy",
    element: (
      <LegalPageLayout>
        <KYCPolicy />
      </LegalPageLayout>
    ),
  },
  {
    path: "/legal/kyc-aml-policy",
    element: (
      <LegalPageLayout>
        <KYCAMLPolicy />
      </LegalPageLayout>
    ),
  },
  {
    path: "/legal/gdpr-compliance",
    element: (
      <LegalPageLayout>
        <GDPRCompliance />
      </LegalPageLayout>
    ),
  },
  {
    path: "/legal/global-compliance-policy",
    element: (
      <LegalPageLayout>
        <GlobalCompliancePolicy />
      </LegalPageLayout>
    ),
  },

  // Risk & Integrity
  {
    path: "/legal/risk-disclaimer",
    element: (
      <LegalPageLayout>
        <RiskDisclaimer />
      </LegalPageLayout>
    ),
  },
  {
    path: "/legal/trust-safety-policy",
    element: (
      <LegalPageLayout>
        <TrustSafetyPolicy />
      </LegalPageLayout>
    ),
  },
  {
    path: "/legal/platform-integrity-policy",
    element: (
      <LegalPageLayout>
        <PlatformIntegrityPolicy />
      </LegalPageLayout>
    ),
  },

  // Service Providers & Vendors
  {
    path: "/legal/service-provider-agreement",
    element: (
      <LegalPageLayout>
        <ServiceProviderAgreement />
      </LegalPageLayout>
    ),
  },
  {
    path: "/legal/tax-declaration-policy",
    element: (
      <LegalPageLayout>
        <TaxDeclarationPolicy />
      </LegalPageLayout>
    ),
  },
  {
    path: "/legal/termination-policy",
    element: (
      <LegalPageLayout>
        <TerminationPolicy />
      </LegalPageLayout>
    ),
  },
  {
    path: "/legal/third-party-data-processors",
    element: (
      <LegalPageLayout>
        <ThirdPartyDataProcessors />
      </LegalPageLayout>
    ),
  },

  // Revenue & Commission
  {
    path: "/legal/commission-revenue-policy",
    element: (
      <LegalPageLayout>
        <CommissionRevenuePolicy />
      </LegalPageLayout>
    ),
  },
  {
    path: "/legal/affiliate-marketing-policy",
    element: (
      <LegalPageLayout>
        <AffiliateMarketingPolicy />
      </LegalPageLayout>
    ),
  },
  {
    path: "/legal/payout-policy",
    element: (
      <LegalPageLayout>
        <PayoutPolicy />
      </LegalPageLayout>
    ),
  },

  // Content & IP Rights
  {
    path: "/legal/sponsored-content-policy",
    element: (
      <LegalPageLayout>
        <SponsoredContentPolicy />
      </LegalPageLayout>
    ),
  },
  {
    path: "/legal/content-usage-policy",
    element: (
      <LegalPageLayout>
        <ContentUsagePolicy />
      </LegalPageLayout>
    ),
  },
  {
    path: "/legal/user-generated-content-policy",
    element: (
      <LegalPageLayout>
        <UserGeneratedContentPolicy />
      </LegalPageLayout>
    ),
  },
  {
    path: "/legal/intellectual-property-rights",
    element: (
      <LegalPageLayout>
        <IntellectualPropertyRights />
      </LegalPageLayout>
    ),
  },

  // DMCA & Disputes
  {
    path: "/legal/dmca-policy",
    element: (
      <LegalPageLayout>
        <DMCAPolicy />
      </LegalPageLayout>
    ),
  },
  {
    path: "/legal/global-dispute-resolution-policy",
    element: (
      <LegalPageLayout>
        <GlobalDisputeResolutionPolicy />
      </LegalPageLayout>
    ),
  },

  // Instructor & Service Roles
  {
    path: "/legal/instructor-certification-policy",
    element: (
      <LegalPageLayout>
        <InstructorCertificationPolicy />
      </LegalPageLayout>
    ),
  },
  {
    path: "/legal/verification",
    element: (
      <LegalPageLayout>
        <Verification />
      </LegalPageLayout>
    ),
  },

  // User Conduct
  {
    path: "/legal/code-of-conduct",
    element: (
      <LegalPageLayout>
        <CodeOfConduct />
      </LegalPageLayout>
    ),
  },
  {
    path: "/legal/advisor-conduct",
    element: (
      <LegalPageLayout>
        <AdvisorConduct />
      </LegalPageLayout>
    ),
  },
  {
    path: "/legal/community-guidelines",
    element: (
      <LegalPageLayout>
        <CommunityGuidelines />
      </LegalPageLayout>
    ),
  },

  // Jurisdiction & Eligibility
  {
    path: "/legal/jurisdiction-age-policy",
    element: (
      <LegalPageLayout>
        <JurisdictionAgePolicy />
      </LegalPageLayout>
    ),
  },

  // Trademark Notice
  {
    path: "/legal/trademark-notice",
    element: (
      <LegalPageLayout>
        <TrademarkNotice />
      </LegalPageLayout>
    ),
  },
];

export default legalRoutes;
